import React from "react";
import { TextField, FormControl } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ImageTooltip from "../../../common/HelpIconWithTooltip";
import {
  directoryDescription,
  directoryExample,
  ScanPathsDescription,
  ScanPathsExample,
} from "../../NTFS/ntfsConstants";
import { NTFS } from "../dataSourceConstants";
import { Typography } from "material-ui-core";
import { SET_NTFS_DIRECTORIES } from "../../../../redux/constants/constants";

function NTFSPathsAutocomplete({
  title,
  placeholder,
  value,
  existingValues = [],
  errorKey,
  error,
  actionType,
  classes,
  dispatch,
  removeErrorByKey,
  handleAddNew,
  handleAutocompleteTags,
  description,
  example,
  isEditMode,
}) {
  const styledDescription = (
    <Typography>
      <span className={classes.tooltipHeading}>{description}</span>
      <br />
      <span className={classes.tooltipExample}>{example}</span>
    </Typography>
  );

  const mergeUniqueValues = (existingValues = [], newValues = []) => {
    const filteredNewValues = newValues.filter(
      (item) => !existingValues.includes(item),
    );
    return [...existingValues, ...filteredNewValues];
  };

  const handleChange = (_, newValue) => {
    if (isEditMode) {
      // Do NOT allow removal of existing values
      const onlyAdditions = mergeUniqueValues(existingValues, newValue);

      dispatch({
        type: actionType,
        payload: onlyAdditions,
      });
      return;
    }

    // normal behavior (create mode)
    dispatch({
      type: actionType,
      payload: newValue,
    });

    removeErrorByKey(errorKey);
  };


  return (
    <div className={classes.customDirectories}>
      <div className={classes.tooltipContainer}>
        <div>{title}</div>
        <ImageTooltip description={styledDescription} loc={NTFS} />
      </div>

      <FormControl variant="outlined" fullWidth>
        <Autocomplete
          multiple
          freeSolo
          options={[]}
          value={value}
          onChange={handleChange}
          renderTags={(value, getTagProps) =>
            handleAutocompleteTags(value, getTagProps, title)
          }
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              variant="outlined"
              onKeyDown={handleAddNew}
              onBlur={handleAddNew}
              fullWidth
              error={!!error[errorKey]}
              helperText={error[errorKey]}
              placeholder={placeholder}
            />
          )}
        />
      </FormControl>
    </div>
  );
}

export default NTFSPathsAutocomplete;
